import React from "react";
import { SmartContainer } from "../../../styles/Containers";
import { StyledP } from "../../../styles/StyledHTML";
import { TERM_ALBUM } from '../../services/CaptureCollabService'
export const Quote = () => {
    const quotes = [
        {
            quote: "Pro Tip:",
            source: "Think of Tags as Albums. A photo can exist in more than one Tag at a time."
        },
        {
            quote: "Pro Tip:",
            source: 'Think in Filters. Ask "How would I search for this later?"'
        },
        {
            quote: "Pro Tip:",
            source: `You are here because folders weren't working for you. Don't treat ${TERM_ALBUM} like folders.`
        },
        // {
        //     quote: "For every minute spent organizing, an hour is earned",
        //     source: "Anonymous"
        // },
        // {
        //     quote: "Organizing is a journey, not a destination",
        //     source: "Anonymous"
        // },
        // {
        //     quote: "Clutter is nothing more than postponed decisions",
        //     source: "Barbara Hemphill"
        // },
        // {
        //     quote: "It takes as much energy to wish as it does to plan.",
        //     source: "Eleanor Roosevelt"
        // },
        // {
        //     quote: "Out of clutter, find simplicity. From discord, find harmony. In the middle of difficulty lies opportunity.",
        //     source: "Albert Einstein"
        // },
        // {
        //     quote: "For every minute spent organizing, an hour is earned.",
        //     source: "Benjamin Franklin"
        // }
    ];
    const quote = quotes[Math.floor(Math.random() * quotes.length)];
    return (
        <SmartContainer>
            <StyledP italics>{quote?.quote}</StyledP>
            <StyledP light italics>{quote?.source}</StyledP>
        </SmartContainer>
    )
}